<div>
  <div class="header card flex four">
    <div class="title half">
      <img class="logo" src="../../../assets/img/logos/logo-square.png" /><span>
        UrbaDocs
      </span>
    </div>

    <div></div>
    <div class="delog">
      @if (isLogged) {
      <button title="Se déconnecter" (click)="onLogout()"><i class="fa-solid fa-power-off fa-2x"></i></button>
      }
    </div>
  </div>
  <!-- @if (geolocationService.address) {
  <div class="text-center">
    <span>
      {{ geolocationService.address }}
    </span>
  </div>
  } -->
</div>
<router-outlet />

<div id="overlay" #overlay>
  <div class="waiting">
    <div class="spinner-border" style="width: 5rem; height: 5rem" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div #overlayMessage id="overlay-message" style="text-align: center"></div>
</div>
